__turbopack_context__.v({
  "envelope-icon": "OnboardingMessages-module-scss-module__kUtpEG__envelope-icon",
  "instructions-message": "OnboardingMessages-module-scss-module__kUtpEG__instructions-message",
  "logged-in-message-btn-container": "OnboardingMessages-module-scss-module__kUtpEG__logged-in-message-btn-container",
  "message-box": "OnboardingMessages-module-scss-module__kUtpEG__message-box",
  "message-btn-container": "OnboardingMessages-module-scss-module__kUtpEG__message-btn-container",
  "message-btns-container": "OnboardingMessages-module-scss-module__kUtpEG__message-btns-container",
  "message-container": "OnboardingMessages-module-scss-module__kUtpEG__message-container",
  "message-content": "OnboardingMessages-module-scss-module__kUtpEG__message-content",
  "message-content-container": "OnboardingMessages-module-scss-module__kUtpEG__message-content-container",
  "message-secondary": "OnboardingMessages-module-scss-module__kUtpEG__message-secondary",
});
